(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["diesel-fit-filter"] && !Shopify.designMode) return;
  try {
    // Prev/next arrows scroll the fit-tile row (uk uses a swiper; a scroll row matches
  // the look without the dependency). Re-runs are cheap and idempotent.
  (function () {
    function wire(row) {
      if (!row || row.dataset.dffWired) return;
      row.dataset.dffWired = '1';
      var sec = row.closest('.dff');
      if (!sec) return;
      var prev = sec.querySelector('[data-dff-prev]');
      var next = sec.querySelector('[data-dff-next]');
      function step(dir) {
        var tile = row.querySelector('.dff__tile');
        var amount = tile ? tile.getBoundingClientRect().width * 2 : row.clientWidth * 0.6;
        row.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 1;
        if (prev) prev.disabled = row.scrollLeft <= 0;
        if (next) next.disabled = row.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', function () {
        if (row.__dffRaf) return;
        row.__dffRaf = true;
        requestAnimationFrame(function () { row.__dffRaf = false; sync(); });
      }, { passive: true });
      sync();
      // Bring the active tile into view on load.
      var active = row.querySelector('.dff__tile--active');
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ inline: 'start', block: 'nearest' });
      }
    }
    function init() {
      document.querySelectorAll('[data-dff-row]').forEach(wire);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
